import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

type UpdateCommentV2Params = {
  scenarioBuilderClient: ScenarioBuilderClient;
  scenarioId: string;
  commentId: string;
  commentData: string;
};

export const updateCommentV2 = ({
  scenarioBuilderClient,
  scenarioId,
  commentId,
  commentData,
}: UpdateCommentV2Params) => {
  return scenarioBuilderClient.scenarios.updateComment({
    scenarioUuid: scenarioId,
    commentUuid: commentId,
    updateCommentRequest: { comment: commentData },
  });
};
